if (process.env.NODE_ENV === "production") {
  module.exports = require("./cjs/react.production.min.js")
} else {
  module.exports = require("./cjs/react.development.js")
}



//////////////////
// WEBPACK FOOTER
// ./~/@lingui/react/index.js
// module id = 43
// module chunks = 35783957827783 114276838955818 162898551421021